/**
 * Pick a localized version of a Mongo document's fields.
 *
 * @param {object} doc  The full document (may have doc.translations = { ml: {...}, hi: {...} }).
 * @param {string} lang Current i18n language code ("en", "ml", "hi").
 * @param {string[]} fields Fields to attempt to localize. Falls back to base field if missing.
 * @returns {object} A shallow-merged doc where the requested fields are replaced by localized values when available.
 */
export function localize(doc, lang, fields) {
  if (!doc) return doc;
  if (!lang || lang === "en") return doc;
  const tr = doc.translations && doc.translations[lang];
  if (!tr) return doc;
  const out = { ...doc };
  for (const f of fields) {
    if (tr[f] !== undefined && tr[f] !== null && tr[f] !== "") out[f] = tr[f];
  }
  return out;
}

/**
 * Localize the sections array on an initiative doc.
 * Falls back per-section to the English text when localized copy is missing.
 */
export function localizeSections(doc, lang) {
  if (!doc || lang === "en") return doc?.sections || [];
  const trSections = doc.translations?.[lang]?.sections;
  if (!Array.isArray(trSections)) return doc.sections || [];
  return (doc.sections || []).map((s, i) => ({
    heading: trSections[i]?.heading || s.heading,
    body: trSections[i]?.body || s.body,
  }));
}
